import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

/**
 * @deprecated The shef-web design system is being retired. Use `components/Button`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515107520
 */
export const TextLink = styled(Link)`
  color: ${Colors.RADISH};
  text-decoration: none;

  :link,
  :visited,
  :hover,
  :active {
    color: ${Colors.RADISH};
    text-decoration: none;
  }
`;
